module.exports = "/fonts/nucleo-icons.ttf?4466aeec3386b965a2329fdd2b2bbb47";